<template>
    <div id="app">
        <el-container >
            <el-main>
                <img src="../public/logo.png" alt="logo" style="width: 100%">
                <el-form label-position="right" label-width="100px" :model="joinForm"
                         size="medium">
                    <el-form-item label="Room Name">
                        <el-input placeholder="Enter room name" v-model="joinForm.channelName"></el-input>
                    </el-form-item>
                    <el-form-item label="Name">
                        <el-input placeholder="Enter your name" v-model="joinForm.name"></el-input>
                    </el-form-item>
                    <el-form-item class="form-buttons">
                        <el-button type="success" v-on:click="joinRoom">Join Room</el-button>
                        <el-button type="primary" v-on:click="createRoom">Create Room</el-button>
                    </el-form-item>
                </el-form>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    import {Room} from './models/room';
    import $ from 'jquery';

    export default {
        name: 'Admin',
        data() {
            return {
                joinForm: {
                    channelName: '',
                    name: window.app.peerName
                }
            }
        },
        methods: {
            joinRoom: function () {
                window.app.updatePeerName(this.joinForm.name);
                this.$router.push({
                    name: "Join",
                    params: {
                        roomName: this.joinForm.channelName.toLowerCase(),
                        name: this.joinForm.name,
                    }
                });
            },

            createRoom: function () {
                let room = new Room({name: this.joinForm.channelName.toLowerCase()});
                $.when(room.save()).then((response) => {
                    let savedRoom = window.app.findCollection('rooms').add(response.data);
                    window.app.updatePeerName(this.joinForm.name);
                    this.$router.push({
                        name: "Join",
                        params: {
                            room: savedRoom,
                            roomName: savedRoom.name,
                            mainRoom: savedRoom,
                            name: this.joinForm.name
                        }
                    });
                }).fail(e => {
                    alert(e.response.data.name);
                });
            }
        }
    }    
</script>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        height: 100%;
    }

    .el-header {
        text-align: center;
        font-size: xx-large;
    }
</style>

<style scoped>
    .el-main {
        width: 500px;
        min-width: 500px;
        max-width: 500px;
        margin: 55px auto;
    }
    .form-buttons {
        text-align: left;
    }
</style>
